import { useState, useCallback } from "react";
import { ValidateBoleanExists } from "./components/TankFields";
import {
  checkIfContainerKeyExistInWareHouse,
  integrationCodeExists,
} from "api/generated";
import { useClient } from "hooks/useClient";
import { handleAxiosError } from "common/helpers/generalUtils";

export function useContainerValidation() {
  const [containerCodeVS, setContainerCodeVS] = useState<ValidateBoleanExists>({
    validateStatus: false,
    errorMsg: "",
  });
  const [integrationCodeVS, setIntegrationCodeVS] =
    useState<ValidateBoleanExists>();
  const [wellIdentificationKeyVS, setWellIdentificationKeyVS] =
    useState<ValidateBoleanExists>();
  const [tankAndDuctIdentificationKeyVS, setTankAndDuctIdentificationKeyVS] =
    useState<ValidateBoleanExists>();

  const { client } = useClient();

  const checkContainerKey = useCallback(
    (containerKey: string, warehouseId: string) => {
      if (!containerKey || !warehouseId) return;

      checkIfContainerKeyExistInWareHouse({
        client,
        path: {
          warehouseId: warehouseId,
        },
        query: {
          containerKey: containerKey,
        },
      })
        .then(({ data }) => {
          setContainerCodeVS({
            validateStatus: !!data,
            errorMsg: data
              ? `La clave de tanque ${containerKey} ya existe actualmente.`
              : "",
          });
        })
        .catch((err) =>
          handleAxiosError(
            err,
            "No se pudo verificar si existe la clave del contenedor",
          ),
        );
    },
    [client],
  );

  const checkIntegrationCode = useCallback(
    (integrationCode: string) => {
      if (!integrationCode) {
        setIntegrationCodeVS({ validateStatus: false, errorMsg: "" });
        return;
      }

      integrationCodeExists({
        client,
        query: {
          integrationCode: integrationCode,
        },
      })
        .then(({ data }) => {
          setIntegrationCodeVS({
            validateStatus: !!data,
            errorMsg: data
              ? `El código de integración ${integrationCode} ya existe actualmente.`
              : "",
          });
        })
        .catch((err) =>
          handleAxiosError(
            err,
            "No se pudo verificar si existe el código de integración",
          ),
        );
    },
    [client],
  );

  const validateTankDuctKey = useCallback((value: string): boolean => {
    const valid = /^[0-9]{4}$/.test(value);
    setTankAndDuctIdentificationKeyVS(
      valid
        ? { validateStatus: false, errorMsg: "" }
        : {
            validateStatus: true,
            errorMsg:
              "La clave de identificación no es válida, debe contener 4 números",
          },
    );
    return valid;
  }, []);

  const validateWellKey = useCallback((value: string): boolean => {
    const valid = /^[0-9]{4}[A-Z]{3}$/.test(value);
    setWellIdentificationKeyVS(
      valid
        ? { validateStatus: false, errorMsg: "" }
        : {
            validateStatus: true,
            errorMsg: "La clave no es válida: 4 números + 3 letras mayúsculas",
          },
    );
    return valid;
  }, []);

  const resetAllValidation = useCallback(() => {
    setContainerCodeVS({ validateStatus: false, errorMsg: "" });
    setIntegrationCodeVS(undefined);
    setWellIdentificationKeyVS(undefined);
    setTankAndDuctIdentificationKeyVS(undefined);
  }, []);

  return {
    containerCodeVS,
    integrationCodeVS,
    wellIdentificationKeyVS,
    tankAndDuctIdentificationKeyVS,

    checkContainerKey,
    checkIntegrationCode,
    validateTankDuctKey,
    validateWellKey,
    resetAllValidation,
  };
}
